export class CreateOrganizationIdpRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerName",
            "baseName": "providerName",
            "type": "string",
            "format": ""
        },
        {
            "name": "ssoUrl",
            "baseName": "ssoUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "logoutUrl",
            "baseName": "logoutUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "issuerUrl",
            "baseName": "issuerUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "certificate",
            "baseName": "certificate",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateOrganizationIdpRequest.attributeTypeMap;
    }
    constructor() {
    }
}
